import React from "react";
import { Calendar } from "lucide-react";
import WebinarHero from "./WebinarHero";
import WebinarBenefits from "./WebinarBenefits";
import TestimonialsSection from "./TestimonialsSection";
import SpeakerSection from "./SpeakerSection";
import OptimizedRegistration from "./OptimizedRegistration";
import DownloadSection from "./DownloadSection";

const MainLandingPage = () => {
  return (
    <>
      <header className="bg-gray-900 border-b border-white/10 sticky top-0 z-50 w-full absolute">
        <div className="container mx-auto px-2 sm:px-4 lg:px-6 py-2 sm:py-3 md:py-4">
          <div className="flex flex-col sm:flex-row justify-between items-center gap-3 sm:gap-4">
            <div className="flex items-center justify-center sm:justify-start w-full sm:w-auto">
              <div className="logo-container mr-4">
                <img
                  src="/images/Real_state.png"
                  alt="Bernie Logo"
                  className="h-12 w-12 sm:h-14 sm:w-14 lg:h-16 lg:w-16 xl:h-20 xl:w-20 object-contain rounded-lg p-2 hover:scale-105 transition-all duration-300 ease-in-out cursor-pointer flex-shrink-0"
                  style={{
                    filter: 'drop-shadow(0 0 8px rgba(255, 255, 255, 0.8)) drop-shadow(0 0 16px rgba(255, 255, 255, 0.4)) brightness(1.2)',
                    background: 'radial-gradient(circle, rgba(255, 255, 255, 0.1) 0%, transparent 70%)'
                  }}
                />
              </div>
              <div className="logo-text text-lg sm:text-xl lg:text-2xl xl:text-3xl font-bold text-white text-center sm:text-left leading-tight" style={{ textShadow: '0 2px 10px rgba(0, 0, 0, 0.5), 0 0 20px rgba(255, 255, 255, 0.3)' }}>
                BERNADETTE HARRIS
              </div>
            </div>
            <a
              href="#registration"
              className="inline-flex items-center justify-center px-3 py-2 sm:px-4 sm:py-2 text-sm font-medium text-white bg-gradient-to-r from-orange-500 to-red-600 rounded-lg shadow-lg hover:from-orange-600 hover:to-red-700 transition-all duration-200 w-full sm:w-auto max-w-xs sm:max-w-none hover:scale-105">
              <Calendar className="h-4 w-4 mr-1 sm:mr-2" />
              <span className="sm:hidden">Reserve Seat</span>
              <span className="hidden sm:inline">Reserve Your Free Seat</span>
            </a>
          </div>
        </div>
      </header>

      <main>
        <WebinarHero />
        <DownloadSection />
        <WebinarBenefits />
        <SpeakerSection />
        <TestimonialsSection />
        <OptimizedRegistration />
      </main>
    </>
  );
};

export default MainLandingPage;
